<template>
  <section class="px-16 mt-8">
    <loading-flux :value="loadingActions"></loading-flux>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <section class="d-flex flex-column flex-sm-row justify-content-between">
          <h2 class="my-3">Carpetas y Subcarpetas de Documentos</h2>
        </section>
      </v-col>
      <v-col cols="12" lg="12" md="12" sm="12" class="pt-0 pb-3">
        <v-btn
          @click="openModalUpdateOrCreateFolder(null)"
          :disabled="loading"
          color="primary"
          :dark="false"
          class="text-white float-right mt-4 mx-3"
        >
          <i class="mdi mdi-plus me-1"></i>
          Crear Carpeta
        </v-btn>
        <v-btn
          @click="openModalFilterFolders()"
          :disabled="loading"
          color="primary"
          :dark="false"
          class="text-white float-right mt-4"
        >
          <i class="mdi mdi-filter me-1"></i>
          Filtros
        </v-btn>
      </v-col>

      <v-col cols="12" md="12" sm="12" class="mb-2">
        <div
          class="d-flex flex-column justify-content-center mt-16"
          v-if="loading"
        >
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            class="mx-auto"
            indeterminate
          ></v-progress-circular>
          <h4 class="text-center mt-5">
            Cargando Carpetas... Espere por favor
          </h4>
        </div>
        <h4 class="text-center mt-16" v-if="!filters.business_unit && !loading">
          <v-icon color="primary" x-large class="mx-2">
            mdi-alert-circle-outline
          </v-icon>
          Selecciona una <b>Unidad de Negocio</b> en los Filtros para Visualizar
          la Estructura de Carpetas
        </h4>
        <v-treeview
          shaped
          v-if="
            foldersTreeViewMaintainer.length &&
            !loading &&
            filters.business_unit
          "
          :open="foldersOpened"
          v-model="documentsTree"
          :items="foldersTreeViewMaintainer"
          item-key="id"
          open-on-click
          @update:open="foldersOpened = $event"
          :hoverable="false"
        >
          <template v-slot:label="{ item, open }">
            <div class="d-flex align-items-center" v-if="item.children">
              <v-icon @click="open = !open" class="mr-1">
                {{ open ? "mdi-folder-open" : "mdi-folder" }}
              </v-icon>
              <h5 class="mt-2 mx-2" v-if="item.children">
                {{ item.name }}
              </h5>
              <div
                class="d-flex align-items-center justify-content-center mx-3"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click.stop="openModalUpdateOrCreateFolder(item, false)"
                      icon
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      class=""
                      large
                    >
                      <v-icon> mdi-folder-plus </v-icon>
                    </v-btn>
                  </template>
                  <span>Añadir Subcarpeta</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click.stop="openModalUpdateOrCreateFolder(item, true)"
                      icon
                      color="warning"
                      v-bind="attrs"
                      v-on="on"
                      large
                    >
                      <v-icon> mdi-pencil-box </v-icon>
                    </v-btn>
                  </template>
                  <span>Editar Carpeta</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click.stop="deleteFolder(item)"
                      icon
                      color="red darken-2"
                      v-bind="attrs"
                      v-on="on"
                      large
                    >
                      <v-icon> mdi-folder-remove </v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar Carpeta</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click.stop="openModalSelectionFolderContainer(item)"
                      icon
                      color="success"
                      v-bind="attrs"
                      v-on="on"
                      large
                    >
                      <v-icon> mdi-folder-move </v-icon>
                    </v-btn>
                  </template>
                  <span>Cambiar Carpeta Contenedora</span>
                </v-tooltip>
              </div>
            </div>
          </template>
        </v-treeview>
        <div
          v-if="
            !foldersTreeViewMaintainer.length &&
            filters.business_unit &&
            !loading
          "
          class="text-center mt-16"
        >
          <v-icon size="50" color="warning">mdi-alert-circle</v-icon>
          <h5 class="mt-5">No hay Carpetas para Mostrar</h5>
        </div>
      </v-col>
    </v-row>
    <modal-selection-folder-container
      :modalAction="dialogSelectionFolderContainer"
      ref="modalSelectionFolderContainer"
      :closeModalSelectionFolderContainer="closeModalSelectionFolderContainer"
      :currentFolder="currentFolderSelection"
      @folderSelected="getFoldersDocumentsData(1)"
      :isProject="isProject"
      :isPresale="isPresale"
    >
    </modal-selection-folder-container>
    <modal-update-or-create-folder
      ref="modalUpdateOrCreateFolder"
      :modalAction="dialogUpdateOrCreateFolder"
      :closeModalCreateOrUpdateFolder="closeModalCreateOrUpdateFolder"
      :currentFolder="currentFolder"
      :parentFolder="parentFolder"
      @folderCreatedOrUpdated="
        getFoldersDocumentsData(1);
        $emit('folderCreatedOrUpdated');
      "
      :isProject="isProject"
      :isPresale="isPresale"
    >
    </modal-update-or-create-folder>
    <filters
      :modalAction="dialogFilterFolders"
      :closeModalFilterFolders="closeModalFilterFolders"
      @clearAllFilters="clearAllFilters"
      @searchFilters="searchFilters"
      :isProject="isProject"
      :isPresale="isPresale"
    >
    </filters>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { TYPES_FOLDER } from "@/constants/documents/maintainers";
import ModalUpdateOrCreateFolder from "./ModalUpdateOrCreateFolder.vue";
import { authUsuarioComputed } from "@/state/helpers";
import Filters from "./Filters.vue";
import ModalSelectionFolderContainer from "./ModalSelectionFolderContainer.vue";
import { filterDeletedFolders } from "@/helpers/document";

export default {
  components: {
    ModalUpdateOrCreateFolder,
    Filters,
    ModalSelectionFolderContainer,
  },
  props: {
    isProject: {
      type: Boolean,
      default: false,
    },
    isPresale: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TYPES_FOLDER,
      dialogUpdateOrCreateFolder: false,
      dialogFilterFolders: false,
      dialogSelectionFolderContainer: false,
      currentFolder: null,
      currentFolderSelection: null,
      parentFolder: null,
      loading: false,
      loadingActions: false,
      debounce: null,
      debounceFolders: null,
      debounceTime: 500,
      documentsTree: [],
      foldersOpened: [],
      filters: {
        page: 1,
        items: 10,
        filter: "",
        business_unit: null,
      },
    };
  },
  mounted() {},
  methods: {
    ...mapActions({
      getAllfoldersDocuments: "document/getAllfoldersDocuments",
      deleteFolderService: "document/deleteFolderDocument",
      updateOrCreateFolderDocument: "document/updateOrCreateFolderDocument",
      getDocumentsFolders: "document/getDocuments",
    }),
    searchFilters(filters) {
      this.filters.filter = filters.filter;
      if (this.businessUnits.length > 1) {
        if (!this.isProject && !this.isPresale) {
          this.filters.business_unit = filters.business_unit;
        }
        if (filters.business_unit) {
          this.$refs.modalUpdateOrCreateFolder.setBusinessUnitForm(
            filters.business_unit
          );
        }
      }
      this.filters.items = filters.items;
      this.getFoldersDocumentsData();
    },
    clearAllFilters() {
      this.filters.filter = null;
      if (this.businessUnits.length > 1) {
        if (!this.isProject && !this.isPresale) {
          this.filters.business_unit = null;
        }
      }
      this.filters.items = 10;
      this.getFoldersDocumentsData();
    },
    async getFoldersDocumentsData(page = 1) {
      clearTimeout(this.debounce);
      let self = this;
      this.debounce = await setTimeout(async function () {
        self.loading = true;
        self.filters.page = page;
        await self.getDocumentsFolders({
          folder_filter: self.filters.filter,
          business_unit_filter: self.filters.business_unit,
          project_code: self.isProject
            ? self.$route.params.codigoProyecto
            : undefined,
          pre_project_code: self.isPresale
            ? self.$route.params.codePresale
            ? self.$route.params.codePresale
            : self.$route.query.code
            : undefined,
          maintainer: true,
          clear: self.filters.business_unit ? false : true,
        });
        self.keyTableFolders = self.keyTableFolders + 1;
        self.loading = false;
      }, self.debounceTime);
    },
    openModalUpdateOrCreateFolder(folder, edit = false) {
      if (!edit && folder) {
        this.parentFolder = folder;
      } else {
        this.currentFolder = folder;
      }
      if (!folder && this.businessUnits.length == 1) {
        this.$refs.modalUpdateOrCreateFolder.setBusinessUnitUser();
      }
      this.dialogUpdateOrCreateFolder = true;
    },
    closeModalCreateOrUpdateFolder() {
      this.currentFolder = null;
      this.parentFolder = null;
      this.dialogUpdateOrCreateFolder = false;
    },
    openModalFilterFolders() {
      this.dialogFilterFolders = true;
    },
    closeModalFilterFolders() {
      this.dialogFilterFolders = false;
    },
    reasignedFolder(folder) {
      this.$emit("reasignedFolder", folder);
    },
    async openModalSelectionFolderContainer(folder) {
      this.currentFolderSelection = folder;
      this.dialogSelectionFolderContainer = true;
      let foldersTreeViewMaintainer = await this.getDocumentsFolders({
        business_unit_filter: this.filters.business_unit,
        project_code: this.isProject
          ? this.getCodeProjectFromParamsOrQuery
          : undefined,
        pre_project_code: this.isPresale
          ? this.$route.params.codePresale
          : undefined,
        not_committed: true,
      });
      this.$refs.modalSelectionFolderContainer.setFoldersToSelect(
        filterDeletedFolders(foldersTreeViewMaintainer),
        true
      );
    },
    closeModalSelectionFolderContainer() {
      this.currentFolderSelection = null;
      this.dialogSelectionFolderContainer = false;
    },
    async deleteFolder(folder) {
      let self = this;
      this.$swal
        .fire({
          icon: "warning",
          title:
            "¿Estás seguro de eliminar la carpeta con nombre: " +
            folder.name +
            "?",
          text: "Esta acción no se puede deshacer",
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "red",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            this.loadingActions = true;
            const resp = await this.deleteFolderService({
              folder_id: folder.id,
              confirm: false,
            });
            if (resp.status == 200) {
              this.$swal.fire({
                icon: "success",
                title: "Excelente",
                text:
                  "La carpeta con nombre: " +
                  folder.name +
                  " ha sido eliminada",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 5000,
                timerProgressBar: true,
              });
              this.$emit("folderCreatedOrUpdated");
              this.getFoldersDocumentsData();
            }
            if (!resp.status || resp.status === 400) {
              this.loadingActions = false;
              this.$swal
                .fire({
                  icon: "warning",
                  title: `La carpeta con nombre: <b>${folder.name}</b> posee documentos asociados, una vez que la carpeta sea eliminada, los documentos asociados serán eliminados también, ¿está seguro de eliminar la carpeta?`,
                  text: "Esta acción no se puede deshacer",
                  showCancelButton: true,
                  confirmButtonText: "Eliminar",
                  denyButtonText: `Reubicar Documentos`,
                  cancelButtonText: "Cancelar",
                  confirmButtonColor: "red",
                  reverseButtons: true,
                  showDenyButton: true,
                  denyButtonColor: "green",
                })
                .then(async (result) => {
                  if (result.isDenied) {
                    this.reasignedFolder(folder);
                    return;
                  }
                  if (result.value) {
                    this.loadingActions = true;
                    const resp = await this.deleteFolderService({
                      folder_id: folder.id,
                      confirm: true,
                    });
                    if (resp.status == 200) {
                      this.loadingActions = false;
                      this.$swal.fire({
                        icon: "success",
                        title: "Excelente",
                        text:
                          "La carpeta con nombre: " +
                          folder.name +
                          " ha sido eliminada",
                        position: "top-end",
                        showConfirmButton: false,
                        toast: true,
                        timer: 5000,
                        timerProgressBar: true,
                      });
                      this.$emit("folderCreatedOrUpdated");
                      this.getFoldersDocumentsData();
                    }
                  }
                });
            }
            this.loadingActions = false;
          }
        });
    },
    getCodeProjectFromParamsOrQuery(){
      return this.$route.params.codigoProyecto || this.$route.query.code  
    }
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      foldersDocuments: "document/foldersDocuments",
      foldersDocumentsFromBusinessUnit:
        "document/foldersDocumentsFromBusinessUnit",
      businessUnits: "document/businessUnits",
      currentProject: "project/currentProject",
      currentPresale: "presale/presale",
      foldersTreeViewMaintainer: "document/foldersTreeViewMaintainer",
    }),
    optionsFolders() {
      return [
        {
          text: "Carpeta",
          value: TYPES_FOLDER.folder,
        },
        {
          text: "Subcarpeta",
          value: TYPES_FOLDER.subfolder,
        },
      ];
    },
  },
  watch: {
    "filters.page": function (page) {
      this.getFoldersDocumentsData(page);
    },
    businessUnits: function (bussinesUnits) {
      if (bussinesUnits.length > 1) {
        if (this.isProject || this.isPresale) {
          this.filters.business_unit = this.currentPresale.business_unit.name;
          this.getFoldersDocumentsData();
        }
      } else {
        this.filters.business_unit = this.businessUnits.length
          ? this.businessUnits[0].name
          : null;
        if (this.filters.business_unit) {
          this.getFoldersDocumentsData();
        }
      }
    },
  },
};
</script>

<style></style>
